package com.evoapps.evoshift.ui.adaptive

import androidx.compose.runtime.Composable

/** A browser draws its own bars. */
@Composable
actual fun SystemBarIcons(darkStatusIcons: Boolean, darkNavigationIcons: Boolean) = Unit

@Composable
actual fun HostBackground(color: androidx.compose.ui.graphics.Color) = Unit
